<div>
  <div class="teaser" style="background-image: url(&quot;images/teaser.png&quot;)">
    <h1 i18n>Innovate Farming Together</h1>
    <p i18n>Join us in innovating farming: Explore and <span class="highlight">influence</span> our upcoming ideas</p>
    <app-button variant="tertiary" size="large" (buttonClick)="doSignUp()">
      <span i18n>Get started</span>
    </app-button>
  </div>
  <div class="page-wrapper product-description">
    <p i18n>
      InnovationHub is our space for exploring emerging ideas in farming. We're excited to share these early-stage
      concepts with you to gather your insights. Your feedback will help shape them into valuable tools for your farm.
      Join and help us grow the future - your input makes all the difference! Let's Innovate Farming Together!
    </p>
  </div>
  <div class="steps page-wrapper">
    <div>
      <div class="step">
        <app-bullet size="small"><span i18n>1</span></app-bullet>
        <h2 i18n>Sign up for free</h2>
        <p i18n>It's easy to get started</p>
      </div>
      <div class="step">
        <app-bullet size="small"><span i18n>2</span></app-bullet>
        <h2 i18n>Discover and explore</h2>
        <p i18n>Dive into the features and ideas you find interesting</p>
      </div>
      <div class="step">
        <app-bullet size="small"><span i18n>3</span></app-bullet>
        <h2 i18n>Share your thoughts and feedback</h2>
        <p i18n>We value your input, it guides our direction</p>
      </div>
      <p i18n>
        When you share your feedback with us, you nurture our ideas, allowing them to grow into valuable features and
        products. By collecting your feedback, we ensure that our ideas develop in ways that meet our users' needs and
        support them in their daily work.
      </p>
    </div>
    <img src="images/landing-steps.png" i18n-alt alt="steps" />
  </div>
  <div class="features">
    <div class="page-wrapper">
      <h3 i18n>Explore our features</h3>
      <p i18n>
        Discover ready-to-use features alongside early-stage ideas and prototypes. We share new concepts to gather your
        feedback, ensuring we meet your needs and deliver value. Your input helps us improve and guides our future
        development.
      </p>
      <div class="cards">
        <div class="card">
          <img src="images/landing_geo-bird.png" i18n-alt alt="Geo-Bird" />
          <h4 i18n>Geo-Bird - Wayline management</h4>
          <p i18n class="with-image">
            Create optimized waylines in just a few easy steps and use them in your fields.
            <img src="icons/geo-bird.svg" i18n-alt alt="Geo-Bird logo" />
          </p>
        </div>
        <div class="card">
          <img src="images/landing_data-converter.png" i18n-alt alt="Guidance Data Converter" />
          <h4 i18n>Guidance Data Converter</h4>
          <p i18n>
            Easily upload your field boundaries, guidance lines, and obstacles, and convert them into the formats you
            need.
          </p>
        </div>
        <div class="card">
          <img src="images/landing_soil-compaction.png" i18n-alt alt="Soil Compaction" />
          <h4 i18n>Soil Compaction</h4>
          <p i18n>Reduce soil compaction with intelligent route planning.</p>
        </div>
      </div>
      <p i18n class="more">... and other innovative features and ideas</p>
    </div>
  </div>
  <div class="cta-section page-wrapper">
    <div>
      <h4 i18n>Get started today</h4>
      <p i18n>Let's innovate farming together!</p>
    </div>
    <app-button variant="inverted" (buttonClick)="doSignUp()">
      <span i18n>Sign up</span>
    </app-button>
  </div>
  <div class="helper">
    <h5 i18n>Need help?</h5>
    <p i18n>
      Send an e-mail to
      <app-link variant="basic" target="_self" href="mailto:support@agco-innovationhub.com">
        support&#64;agco-innovationhub.com
      </app-link>
    </p>
  </div>
</div>
